import { render, staticRenderFns } from "./ContactsEditor.vue?vue&type=template&id=c6560ae0&scoped=true&"
import script from "./ContactsEditor.vue?vue&type=script&lang=js&"
export * from "./ContactsEditor.vue?vue&type=script&lang=js&"
import style0 from "./ContactsEditor.vue?vue&type=style&index=0&id=c6560ae0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6560ae0",
  null
  
)

export default component.exports